import React from "react";

export default () => {

    return <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M14.0813 10.3313L7.83128 16.5813C7.74242 16.6641 7.62489 16.7092 7.50345 16.707C7.38201 16.7049 7.26615 16.6557 7.18026 16.5698C7.09438 16.4839 7.04518 16.368 7.04304 16.2466C7.0409 16.1252 7.08598 16.0076 7.16878 15.9188L13.0867 10L7.16878 4.08128C7.08598 3.99242 7.0409 3.87489 7.04304 3.75345C7.04518 3.63201 7.09438 3.51615 7.18026 3.43026C7.26615 3.34438 7.38201 3.29518 7.50345 3.29304C7.62489 3.2909 7.74242 3.33598 7.83128 3.41878L14.0813 9.66878C14.1691 9.75667 14.2184 9.87581 14.2184 10C14.2184 10.1242 14.1691 10.2434 14.0813 10.3313Z" fill="currentColor"/>
    </svg>


}
